import React, { Component } from "react";
import { Button, Image, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  formatNumber,
  getColor,
  dayAgo,
  replaceCharacterWith,
  dateFormat,
  getLocalstorage
} from "../../helper";
import IconMore from "../../assets/icon-more.svg";
import IconTime from "../../assets/icon-time.svg";
import info from "../../assets/info_crit.svg";
import project_AI_icon from "../../assets/project_AI_icon.svg";
import { get } from "lodash";
import { Pragati } from "../prgatiReview";
import { Pli } from "../pliReview";
import { Nip } from "../nipReview";
import { DownloadExcelReport, RedirectUser } from "../reusableComponent";
import {
  getDownloadProjectDetailAction,
  clearDownloadProjectDetailAction,
  getDownloadMilestoneAudit,
  clearDownloadMilestoneAudit
} from "../../actions/dowloadExcelActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PermissionHoc from "../PermissionHOC";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import { PmgsHipimage } from "../pmgsHipp/pmgsHip";
import { March24 } from "../march24";
import { AIprojectsummary } from "./AIprojectsummary";
import { PragatiPipeline } from "../prgatiReview/pragatiPipeline";
import CriticalityScore from "../../component/CriticalityBar";

class ProjectDetailsSideBar extends Component {
  state = {
    includeDescription: false,
    showOtherPPList: false,
    isOpen: false
  };

  componentWillUnmount() {
    this.onClearDownload();
  }
  handleClick = value => {
    this.setState({
      isOpen: value
    });
  };
  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  // on clear download button
  onClearDownload = () => {
    const { clearDownloadProjectDetailAction } = this.props;
    clearDownloadProjectDetailAction();
  };

  clearDownloadMilestoneAudit = () => {
    const { clearDownloadMilestoneAudit } = this.props;
    clearDownloadMilestoneAudit();
  };

  // on downloading
  onDownloading = () => {
    try {
      const { includeDescription } = this.state;
      const { getDownloadProjectDetailAction, data } = this.props;
      getDownloadProjectDetailAction(undefined, {
        projectId: data.id,
        includeDescription
      });
    } catch (error) {
      console.error("Error while download project action ", error.message);
    }
  };

  onMilestoneAuditDownloading = () => {
    try {
      const { getDownloadMilestoneAudit, data } = this.props;
      getDownloadMilestoneAudit(undefined, data && data.id);
    } catch (error) {
      console.error("Error while download project action ", error.message);
    }
  };

  handlePrint = () => {
    window.print();
  };

  onChangeIncludeDescription = () => {
    this.setState(prevState => ({
      includeDescription: !prevState.includeDescription
    }));
  };

  render() {
    const {
      props: {
        projectCost,
        data,
        permission,
        handleShow,
        ProjectDetails,
        toggleProjectDetails,
        projectDetailDocumentDownloadReducer,
        milestoneAuditDownload,
        onToggleCommentSection
      },
      onDownloading,
      onClearDownload,
      onChangeIncludeDescription,
      clearDownloadMilestoneAudit,
      onMilestoneAuditDownloading
    } = this;
    const { showOtherPPList, isOpen } = this.state;
    const status =
      get(data, "status") &&
      replaceCharacterWith(get(data, "status", "NA"), "_", " ").toLowerCase();

    const isResolved =
      get(data, "projectStatusWithRespectToIssueStatus") === "RESOLVED";

    const projectResolutionDate = get(data, "projectResolutionDate")
      ? dateFormat(get(data, "projectResolutionDate"))
      : "NA";

    const createdBy =
      data && data.projectPPList && data.projectPPList.length
        ? data.projectPPList[0]
        : null;
    const projectPPList =
      data && data.projectPPList && data.projectPPList.length
        ? data.projectPPList
        : [];
    const userInfo = getLocalstorage("user");
    const centralProjects = get(data, "workflowType") == "CENTRAL";
    const Critscore = get(data, "criticalScore", null);
    return (
      <React.Fragment>
        <div className="sidebar-container">
          <div className="button-group">
            <Image src={IconMore} alt="More" className="icon-more" />

            <div className="button-group-inner">
              {" "}
              {/*button-group-show*/}
              {isOpen ? (
                <AIprojectsummary
                  isOpen={isOpen}
                  onClick={this.handleClick}
                  projectData={data}
                />
              ) : null}
              {centralProjects && status != "under verification" ? (
                <div className="tooltip-wrapper">
                  <div
                    className="ai-icon-wrapper project_ai_button"
                    onClick={this.handleClick}
                  >
                    <div className="ai-icon-button active">
                      <div className="ai-icon-ring">
                        <div className="ai-icon-gradient" />
                      </div>

                      <div className="ai-icon-ring">
                        <div className="ai-icon-gradient" />
                        <div className="ai-icon-fill" />

                        <div className="ai-icon-content">
                          <Image src={project_AI_icon} alt="AI Icon" />
                        </div>
                      </div>

                      <span className="ai-text-project-detail">AI Summary</span>
                    </div>
                  </div>

                  <span className="custom-tooltip">Project AI Summary</span>
                </div>
              ) : null}
              <Button
                className="btn-blue no-padding hidden-desktop"
                onClick={handleShow}
              >
                <div className="edit-icon orange" />
                Edit project details
              </Button>
              <div className="excel-wrapper">
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      id="tooltip-project-brief"
                      className={`project-details-tooltip ${""}`}
                    >
                      {"Project Brief"}
                    </Tooltip>
                  }
                >
                  <div>
                    <DownloadExcelReport
                      isLoading={projectDetailDocumentDownloadReducer.isLoading}
                      downloadLink={
                        projectDetailDocumentDownloadReducer.downloadingSrc
                      }
                      onClearDownload={onClearDownload}
                      onStartDownloading={onDownloading}
                      iconClassName="doc-icon"
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      id="tooltip-milestone-history"
                      className={`project-details-tooltip ${""}`}
                    >
                      {"Milestones Update History"}
                    </Tooltip>
                  }
                >
                  <div
                    className="download-excel-component"
                    style={{ border: "none", marginLeft: 0 }}
                  >
                    <div style={{ marginRight: -30 }}>
                      <DownloadExcelReport
                        isLoading={
                          milestoneAuditDownload &&
                          milestoneAuditDownload.isLoading
                        }
                        downloadLink={
                          milestoneAuditDownload &&
                          milestoneAuditDownload.downloadingSrc
                        }
                        onClearDownload={clearDownloadMilestoneAudit}
                        onStartDownloading={onMilestoneAuditDownloading}
                        //iconClassName="doc-icon"
                      />
                    </div>
                  </div>
                </OverlayTrigger>

                <Form.Check
                  type="checkbox"
                  label="Download with issue description"
                  className="download-check-box"
                  onChange={onChangeIncludeDescription}
                  style={{ left: "-72px", position: "relative" }}
                />
              </div>
              {get(data, "allowToViewNote") ? (
                <Button
                  onClick={onToggleCommentSection}
                  className="btn-small note-btn print-btn print-project"
                  style={{ marginRight: 5 }}
                >
                  <div className="note-icon" style={{ top: "0" }} />
                  Note
                </Button>
              ) : null}
              <Button
                className="btn-orange-invert btn-small print-btn print-project"
                onClick={this.handlePrint}
              >
                <div className="print-icon orange" />
                Print
              </Button>
            </div>
          </div>

          <div className="issue-list-status">
            {get(data, "terminatedDate", null) ? (
              <div className="date-terminated">
                <Image src={IconTime} alt="Time" />
                <span>{dateFormat(get(data, "terminatedDate", null))}</span>
              </div>
            ) : null}
            {/* {console.log("isResolved", isResolved)} */}
            {/* <div className="issue-list-status-inner">
              {!isResolved ? (
                <div className="resolution-date">
                  <div> Resolved on </div>
                  <div className="second-row">
                    <Image src={IconTime} alt="Time" />
                    <span>{projectResolutionDate}</span>
                  </div>
                </div>
              ) : null}
            </div> */}
            <Button
              className={`btn-extra-small ${getColor(status)} unClickable`}
            >
              {status}
            </Button>
          </div>
          {Critscore && (
            <>
              <div
                style={{
                  fontSize: "12px",
                  fontFamily: "mpsb",
                  paddingBottom: "4px",
                  marginTop: "5px"
                }}
              >
                Criticality Score (
                {Critscore !== null ? parseFloat(Critscore).toFixed(1) : "--"}
                /5)
                <OverlayTrigger
                  defaultShow={false}
                  placement={"top"}
                  overlay={
                    <Tooltip id={``} className={"critical-rate-tooltip-detail"}>
                      <span>
                        Project criticality based on delays, issue severity, and
                        implementation risks
                      </span>
                      <br />
                      <span className="AI-tooltip-text">
                        The score is AI-generated and may not be fully accurate
                      </span>
                    </Tooltip>
                  }
                >
                  <Image
                    style={{ paddingBottom: "1px", paddingLeft: "2px" }}
                    src={info}
                  />
                </OverlayTrigger>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {data && (
                  <CriticalityScore value={get(data, "criticalScore")} />
                )}
              </div>
            </>
          )}

          <div className="display-flex flex-wrap-reverse justify-content-end mt-auto tag-style">
            <PmgsHipimage
              className={"pragati-review-project-detail"}
              isValidProject={get(data, "pmGsHipDTO.pmgsHip")}
            />
            <Pragati
              className={"pragati-review-project-detail"}
              isValidProject={get(data, "pragatiDTO.pragatiReview")}
            />

            {/* <PragatiPipeline
              className={'pragati-review-project-detail'}
              isValidProject={get(data, 'pragatiDTO.pragatiPipeline')}
            /> */}
            <PragatiPipeline
              className={"pragati-review-project-detail"}
              isValidProject={
                !get(data, "pragatiDTO.pragatiReview") &&
                get(data, "pragatiDTO.pragatiPipeline")
              }
            />
            <March24
              className={"pragati-review-project-detail"}
              isValidProject={get(data, "march24DTO.march24")}
            />
            <Nip
              className={"pragati-review-project-detail"}
              isValidProject={get(data, "nipDTO.nipReview")}
            />
            <PmFoundationStone
              className={"pragati-review-project-detail"}
              isValidProject={get(
                data,
                "pmFoundationStoneDTO.pmFoundationStone"
              )}
            />
            <CmPragatiYatra
              className={"pragati-review-project-detail"}
              isValidProject={get(data, "cmPragatiYatraDTO.cmPragatiYatra")}
            />
            <CmFoundationStone
              className={"pragati-review-project-detail"}
              isValidProject={get(
                data,
                "cmFoundationStoneDTO.cmFoundationStone"
              )}
            />
            <PmGatiShakti
              className={"pragati-review-project-detail"}
              isValidProject={get(data, "pmGatiShaktiNewDTO.pmGatiShaktiNew")}
            />
            {get(data, "implMode") === "PRIVATE" && (
              <Pli
                className={"pragati-review-project-detail"}
                isValidProject={get(data, "pliDTO.pli")}
              />
            )}
          </div>
          <div class="project-details-wrapper">
            <div class="project-cost">
              <div class="cost-heading">Project Cost</div>
              <div class="cost">
                {" "}
                {parseFloat(projectCost) !== 0 ? `₹ ${projectCost} Cr.` : "N/A"}
              </div>
            </div>
          </div>
          <div className="created-by">
            <span
              className={`created-by-user ${createdBy &&
                createdBy.verified &&
                "verified-user"}`}
            />
            <span className="first-pp-name">
              <RedirectUser
                title={get(createdBy, "name", null)}
                id={get(createdBy, "id", null)}
              />
            </span>
            {projectPPList && projectPPList.length > 1 ? (
              <div
                className={`dropdown field-sort ${
                  showOtherPPList ? "visible" : ""
                }`}
                onClick={this.toggleOtherPPList}
              >
                <div
                  className={`dropdown-overlay ${
                    showOtherPPList ? "visible" : ""
                  }`}
                />
                <div className="dropdown-selected-value">
                  + {projectPPList.length - 1}
                </div>
                <div className="dropdown-option-list hidden-mobile">
                  <div className="dropdown-option-list-heading">
                    {/* <div className="list-sort">Sort By</div>
                            <Image src={IconClose} alt="Close Icon" />*/}
                  </div>
                  {projectPPList
                    ? projectPPList.map((value, index) => {
                        if (index !== 0) {
                          return (
                            <RedirectUser
                              title={get(value, "name", null)}
                              id={get(value, "id", null)}
                              isProjectProponentDetail={true}
                            />
                          );
                        }
                      })
                    : null}
                </div>
              </div>
            ) : null}
            <span className="seperator">|</span>
            <span>
              {get(data, "verificationDate")
                ? `Verified on
                      ${dateFormat(get(data, "verificationDate", null))}
                    `
                : `
                    Created on
                    ${dateFormat(get(data, "createdDate", null))}
                    `}
            </span>
          </div>

          <Button
            className="btn-orange-invert no-padding hidden-desktop hidden-mobile show-hide-button"
            onClick={toggleProjectDetails}
          >
            {ProjectDetails ? "Hide details" : "Show details"}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectDetailDocumentDownloadReducer:
      state.donwloadExcelReducer.projectDetailDocumentDownload,
    milestoneAuditDownload: state.donwloadExcelReducer.milestoneAuditDownload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadProjectDetailAction,
      clearDownloadProjectDetailAction,
      getDownloadMilestoneAudit,
      clearDownloadMilestoneAudit
    },
    dispatch
  );
}

export default PermissionHoc(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProjectDetailsSideBar)
);
